import { useState } from "react";

import { CancelButtons } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelButtons";
import { NormalText } from "@/components/text/NormalText";
import { cancelSubscriptionAction } from "@/data/payment/actions/cancelSubscriptionAction";
import { logError } from "@/utils/logError";

export function ConfirmCancellation({
  closeModal,
  onCancel,
  title,
}: {
  closeModal: () => void;
  onCancel: (cancelledImmediately: boolean) => void;
  title: string;
}) {
  const [hasCancellationFailed, setHasCancellationFailed] = useState(false);

  return (
    <div className="space-y-4">
      <NormalText elementType="p">{title}</NormalText>
      {hasCancellationFailed ?
        <NormalText elementType="p" className="text-red-600">
          Something went wrong and we couldn't confirm your cancellation. Please
          reload the page before trying again.
        </NormalText>
      : null}
      <CancelButtons
        positiveText="Keep subscription"
        negativeText="Cancel"
        onPositive={closeModal}
        onNegative={async () => {
          setHasCancellationFailed(false);
          try {
            const result = await cancelSubscriptionAction();
            if (result.status === "cancelled") {
              onCancel(result.cancelledImmediately);
              return;
            }
            // Nothing was cancelled (signed out or no live subscription) — close (which re-syncs the account page) instead of announcing a cancellation that never happened.
            closeModal();
          } catch (error) {
            // Stay on this step so the user can retry — an unhandled rejection here would leave them unsure whether the cancellation happened.
            logError(error);
            setHasCancellationFailed(true);
          }
        }}
      />
    </div>
  );
}
